import { isDemoMode } from '@/lib/demo-mode';

export function DemoBanner() {
  if (!isDemoMode) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-amber-500 to-orange-500 text-white py-2 px-4 text-center text-sm font-medium shadow-lg">
      🎭 Demo Mode - All data is simulated for demonstration purposes
    </div>
  );
}
